@let chatMessages = groupedChatMessages();
@let loadingChatMessages = chatMessages?.length > 0;

@defer (when loadingChatMessages) {
    <div class="ap-flex ap-flex-grow-1 chat-position-relative">
        <div
            class="ap-flex-grow-1 ap-padding-horizontal-2 ap-padding-top-2 ap-margin-bottom-2 ap-flex-fill conversational-chat-message-container"
            #scrollChatContainer
            [attr.aria-label]="'klant.conversational.aria.chatmessages' | apContent"
        >
            <conversational-chat-disclaimer></conversational-chat-disclaimer>

            @for (chatMessage of chatMessages; track chatMessage.occurredAt; let isLastMessage = $last) {
                @if (chatMessage.firstOfDate && chatMessage.messageDate) {
                    <message-date-divider [date]="chatMessage.messageDate"></message-date-divider>
                }
                <conversational-chat-message
                    [chatMessage]="chatMessage"
                    [isLastMessage]="isLastMessage"
                    [showAvatar]="chatMessage.showAvatar || false"
                    (sendAction)="onSendAction($event)"
                >
                </conversational-chat-message>
            }
            @if (messageLoading()) {
                <message-loader
                    [avatarBotOrLive]="botOrLivechatAvatar()"
                    [showAvatar]="showMessageLoaderAvatar()"
                    class="ap-flex ap-margin-bottom-2 ap-justify-content-start"
                ></message-loader>
            }
        </div>
    </div>

    <conversational-chat-input
        #chatInputContainer
        [attr.aria-label]="'klant.conversational.aria.inputarea' | apContent"
        class="ap-flex ap-flex-column ap-justify-content-end ap-margin-horizontal-1 ap-margin-top-2"
        (sendMessage)="onSendMessage($event)"
    >
    </conversational-chat-input>
} @placeholder {
    <conversational-chat-skeleton></conversational-chat-skeleton>
}
